import React from "react";
import "./landing.css";
import SNS from "./sections/SNS";
import AboutUs from "./sections/AboutUs";
import Product from "./sections/Product";
import EventDetails from "./sections/EventDetails";
import ContactUs from "./sections/ContactUs";
import Book from "./sections/Book";
import INFO from "./sections/INFO";

const Landing = () => {
  return (
    <div className="landing-container">
      <main className="landing-main">
        <AboutUs />
        <div className="content-card">
          <Product />
          <EventDetails />
          <ContactUs />
          <Book />
          <SNS />
        </div>
        <div className="footer-info">
          <INFO />
        </div>
      </main>
    </div>
  );
};

export default Landing;
